import axios from "axios";

const getSelectedLocationId = () => {
  const savedLocationData = sessionStorage.getItem("selectedLocationData");
  if (savedLocationData) {
    try {
      const locationData = JSON.parse(savedLocationData);
      return locationData._id || locationData.id || null;
    } catch (error) {
      console.error("Error parsing selectedLocationData:", error);
    }
  }

  const selectedLocation = sessionStorage.getItem("selectedLocation");
  if (selectedLocation) {
    try {
      return JSON.parse(selectedLocation);
    } catch (error) {
      return selectedLocation;
    }
  }

  return null;
};

export const fetchPaymentSummaryData = async ({
  fromDate,
  toDate,
  hasMultipleLocations,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const locations = JSON.parse(sessionStorage.getItem("locations") || "[]");
  const token = sessionStorage.getItem("token");
  const selectedLocationId = getSelectedLocationId();
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || locations.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = hasMultipleLocations
    ? {
        id: selectedLocationId,
        dataurl: "/api/Restaurant/DailyPaymentSummary",
        subdata: {
          loations:
            filteredLocationsId.length > 0 ? filteredLocationsId : locations,
          date: isoDate,
          toDate: isoToDate,
          is_multi_loc,
        },
      }
    : {
        clientid: clientid,
        dataurl: "/api/Restaurant/DailyPaymentSummary",
        subdata: {
          loations: locations,
          date: isoDate,
          toDate: isoToDate,
          is_multi_loc,
        },
      };

  const endpoint = hasMultipleLocations
    ? "multipleLocations-summarydetails"
    : "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  sessionStorage.setItem(
    "clientSettings",
    JSON.stringify(data?.client?.appSettings),
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};

export const fetchPaymentSummaryDataLocwise = async ({
  fromDate,
  toDate,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const token = sessionStorage.getItem("token");
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || filteredLocationsId.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = {
    clientid: clientid,
    dataurl: "/api/Restaurant/DailyPaymentSummary/Locwise",
    subdata: {
      loations: filteredLocationsId.length > 0 && filteredLocationsId,
      date: isoDate,
      toDate: isoToDate,
      is_multi_loc,
    },
  };

  const endpoint = "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};

export const fetchSalesSummaryData = async ({
  fromDate,
  toDate,
  hasMultipleLocations,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const locations = JSON.parse(sessionStorage.getItem("locations") || "[]");
  const token = sessionStorage.getItem("token");
  const selectedLocationId = getSelectedLocationId();
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || locations.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = hasMultipleLocations
    ? {
        id: selectedLocationId,
        dataurl: "/api/Restaurant/DailySalesSummary",
        subdata: {
          loations:
            filteredLocationsId.length > 0 ? filteredLocationsId : locations,
          date: isoDate,
          toDate: isoToDate,
          is_multi_loc,
        },
      }
    : {
        clientid: clientid,
        dataurl: "/api/Restaurant/DailySalesSummary",
        subdata: {
          loations: locations,
          date: isoDate,
          toDate: isoToDate,
          is_multi_loc,
        },
      };

  const endpoint = hasMultipleLocations
    ? "multipleLocations-summarydetails"
    : "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  sessionStorage.setItem(
    "clientSettings",
    JSON.stringify(data?.client?.appSettings),
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};

export const fetchSalesSummaryDataLocwise = async ({
  fromDate,
  toDate,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const token = sessionStorage.getItem("token");
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || filteredLocationsId.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = {
    clientid: clientid,
    dataurl: "/api/Restaurant/DailySalesSummary/Locwise",
    subdata: {
      loations: filteredLocationsId.length > 0 && filteredLocationsId,
      date: isoDate,
      toDate: isoToDate,
      is_multi_loc,
    },
  };

  const endpoint = "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};

export const fetchLiveOrdersData = async ({
  fromDate,
  toDate,
  hasMultipleLocations,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const selectedLocationId = JSON.parse(
    sessionStorage.getItem("selectedLocation") || "null",
  );
  const locations = JSON.parse(sessionStorage.getItem("locations") || "[]");
  const token = sessionStorage.getItem("token");
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || locations.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody =
    hasMultipleLocations || is_multi_loc
      ? {
          id: selectedLocationId,
          dataurl: "/api/Restaurant/DailyLiveOrdersSummary",
          subdata: {
            loations:
              filteredLocationsId.length > 0 ? filteredLocationsId : locations,
            date: isoDate,
            toDate: isoToDate,
            is_multi_loc,
          },
        }
      : {
          clientid: clientid,
          dataurl: "/api/Restaurant/DailyLiveOrdersSummaryMultiLoc",
          subdata: {
            loations:
              filteredLocationsId.length > 0 ? filteredLocationsId : locations,
            date: isoDate,
            toDate: isoToDate,
            is_multi_loc,
          },
        };

  const endpoint = hasMultipleLocations
    ? "multipleLocations-summarydetails"
    : "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  sessionStorage.setItem(
    "clientSettings",
    JSON.stringify(data?.client?.appSettings),
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};

export const fetchTimewiseSummaryData = async ({
  fromDate,
  toDate,
  hasMultipleLocations,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const locations = JSON.parse(sessionStorage.getItem("locations") || "[]");
  const token = sessionStorage.getItem("token");
  const selectedLocationId = getSelectedLocationId();
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || locations.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = hasMultipleLocations
    ? {
        id: selectedLocationId,
        dataurl: "/api/Restaurant/DailyTimewiseSalesSummary",
        subdata: {
          loations:
            filteredLocationsId.length > 0 ? filteredLocationsId : locations,
          date: isoDate,
          toDate: isoToDate,
          is_multi_loc,
        },
      }
    : {
        clientid: clientid,
        dataurl: "/api/Restaurant/DailyTimewiseSalesSummary",
        subdata: {
          loations: locations,
          date: isoDate,
          toDate: isoToDate,
          is_multi_loc,
        },
      };

  const endpoint = hasMultipleLocations
    ? "multipleLocations-summarydetails"
    : "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  sessionStorage.setItem(
    "clientSettings",
    JSON.stringify(data?.client?.appSettings),
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};

export const fetchTimewiseSummaryDataLocwise = async ({
  fromDate,
  toDate,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const token = sessionStorage.getItem("token");
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || filteredLocationsId.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = {
    clientid: clientid,
    dataurl: "/api/Restaurant/DailyTimewiseSalesSummary/Locwise",
    subdata: {
      loations: filteredLocationsId.length > 0 && filteredLocationsId,
      date: isoDate,
      toDate: isoToDate,
      is_multi_loc,
    },
  };

  const endpoint = "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};

export const fetchMonthwiseSummaryData = async ({
  fromDate,
  toDate,
  hasMultipleLocations,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const locations = JSON.parse(sessionStorage.getItem("locations") || "[]");
  const token = sessionStorage.getItem("token");
  const selectedLocationId = getSelectedLocationId();
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || locations.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = hasMultipleLocations
    ? {
        id: selectedLocationId,
        dataurl: "/api/Restaurant/MonthwiseSalesSummary",
        subdata: {
          loations:
            filteredLocationsId.length > 0 ? filteredLocationsId : locations,
          date: isoDate,
          toDate: isoToDate,
          is_multi_loc,
        },
      }
    : {
        clientid: clientid,
        dataurl: "/api/Restaurant/MonthwiseSalesSummary",
        subdata: {
          loations: locations,
          date: isoDate,
          toDate: isoToDate,
          is_multi_loc,
        },
      };

  const endpoint = hasMultipleLocations
    ? "multipleLocations-summarydetails"
    : "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  sessionStorage.setItem(
    "clientSettings",
    JSON.stringify(data?.client?.appSettings),
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};
export const fetchMonthwiseSummaryDataLocwise = async ({
  fromDate,
  toDate,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const token = sessionStorage.getItem("token");
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || filteredLocationsId.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = {
    clientid: clientid,
    dataurl: "/api/Restaurant/MonthwiseSalesSummary/Locwise",
    subdata: {
      loations: filteredLocationsId.length > 0 && filteredLocationsId,
      date: isoDate,
      toDate: isoToDate,
      is_multi_loc,
    },
  };

  const endpoint = "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};

export const fetchDaywiseSummaryData = async ({
  fromDate,
  toDate,
  hasMultipleLocations,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const locations = JSON.parse(sessionStorage.getItem("locations") || "[]");
  const token = sessionStorage.getItem("token");
  const selectedLocationId = getSelectedLocationId();
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || locations.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = hasMultipleLocations
    ? {
        id: selectedLocationId,
        dataurl: "/api/Restaurant/DaywiseSalesSummary",
        subdata: {
          loations:
            filteredLocationsId.length > 0 ? filteredLocationsId : locations,
          date: isoDate,
          toDate: isoToDate,
          is_multi_loc,
        },
      }
    : {
        clientid: clientid,
        dataurl: "/api/Restaurant/DaywiseSalesSummary",
        subdata: {
          loations: locations,
          date: isoDate,
          toDate: isoToDate,
          is_multi_loc,
        },
      };

  const endpoint = hasMultipleLocations
    ? "multipleLocations-summarydetails"
    : "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  sessionStorage.setItem(
    "clientSettings",
    JSON.stringify(data?.client?.appSettings),
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};
export const fetchDaywiseSummaryDataLocwise = async ({
  fromDate,
  toDate,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const token = sessionStorage.getItem("token");
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || filteredLocationsId.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = {
    clientid: clientid,
    dataurl: "/api/Restaurant/DaywiseSalesSummary/Locwise",
    subdata: {
      loations: filteredLocationsId.length > 0 && filteredLocationsId,
      date: isoDate,
      toDate: isoToDate,
      is_multi_loc,
    },
  };

  const endpoint = "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};

export const fetchInvoiceCountData = async ({
  fromDate,
  toDate,
  hasMultipleLocations,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const locations = JSON.parse(sessionStorage.getItem("locations") || "[]");
  const token = sessionStorage.getItem("token");
  const selectedLocationId = getSelectedLocationId();
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || locations.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = hasMultipleLocations
    ? {
        id: selectedLocationId,
        dataurl: "/api/Restaurant/DailyInvoiceCountSummary",
        subdata: {
          loations:
            filteredLocationsId.length > 0 ? filteredLocationsId : locations,
          date: isoDate,
          toDate: isoToDate,
          is_multi_loc,
        },
      }
    : {
        clientid: clientid,
        dataurl: "/api/Restaurant/DailyInvoiceCountSummary",
        subdata: {
          loations: locations,
          date: isoDate,
          toDate: isoToDate,
          is_multi_loc,
        },
      };

  const endpoint = hasMultipleLocations
    ? "multipleLocations-summarydetails"
    : "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  sessionStorage.setItem(
    "clientSettings",
    JSON.stringify(data?.client?.appSettings),
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};
export const fetchInvoiceCountDataLocwise = async ({
  fromDate,
  toDate,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const token = sessionStorage.getItem("token");
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || filteredLocationsId.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = {
    clientid: clientid,
    dataurl: "/api/Restaurant/DailyInvoiceCountSummary/Locwise",
    subdata: {
      loations: filteredLocationsId.length > 0 && filteredLocationsId,
      date: isoDate,
      toDate: isoToDate,
      is_multi_loc,
    },
  };

  const endpoint = "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};

export const fetchWaiterwiseSummaryData = async ({
  fromDate,
  toDate,
  hasMultipleLocations,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const locations = JSON.parse(sessionStorage.getItem("locations") || "[]");
  const token = sessionStorage.getItem("token");
  const selectedLocationId = getSelectedLocationId();
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || locations.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = hasMultipleLocations
    ? {
        id: selectedLocationId,
        dataurl: "/api/Restaurant/DailyWaiterwiseSummary",
        subdata: {
          loations:
            filteredLocationsId.length > 0 ? filteredLocationsId : locations,
          date: isoDate,
          toDate: isoToDate,
          is_multi_loc,
        },
      }
    : {
        clientid: clientid,
        dataurl: "/api/Restaurant/DailyWaiterwiseSummary",
        subdata: {
          loations: locations,
          date: isoDate,
          toDate: isoToDate,
          is_multi_loc,
        },
      };

  const endpoint = hasMultipleLocations
    ? "multipleLocations-summarydetails"
    : "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  sessionStorage.setItem(
    "clientSettings",
    JSON.stringify(data?.client?.appSettings),
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};

export const fetchWaiterwiseSummaryDataLocwise = async ({
  fromDate,
  toDate,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const token = sessionStorage.getItem("token");
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || filteredLocationsId.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();
  const requestBody = {
    clientid: clientid,
    dataurl: "/api/Restaurant/DailyWaiterwiseSummary/Locwise",
    subdata: {
      loations: filteredLocationsId.length > 0 && filteredLocationsId,
      date: isoDate,
      toDate: isoToDate,
      is_multi_loc,
    },
  };

  const endpoint = "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};

export const fetchDailyCancelledProductSummary = async ({
  fromDate,
  toDate,
  hasMultipleLocations,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const locations = JSON.parse(sessionStorage.getItem("locations") || "[]");
  const token = sessionStorage.getItem("token");
  const selectedLocationId = getSelectedLocationId();
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || locations.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = hasMultipleLocations
    ? {
        id: selectedLocationId,
        dataurl: "/api/Restaurant/DailyCancelledProductSummary",
        subdata: {
          loations:
            filteredLocationsId.length > 0 ? filteredLocationsId : locations,
          date: isoDate,
          toDate: isoToDate,
          is_multi_loc,
        },
      }
    : {
        clientid: clientid,
        dataurl: "/api/Restaurant/DailyCancelledProductSummary",
        subdata: {
          loations: locations,
          date: isoDate,
          toDate: isoToDate,
          is_multi_loc,
        },
      };

  const endpoint = hasMultipleLocations
    ? "multipleLocations-summarydetails"
    : "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  sessionStorage.setItem(
    "clientSettings",
    JSON.stringify(data?.client?.appSettings),
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};
export const fetchDailyCancelledProductSummaryLocwise = async ({
  fromDate,
  toDate,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const token = sessionStorage.getItem("token");
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || filteredLocationsId.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = {
    clientid: clientid,
    dataurl: "/api/Restaurant/DailyCancelledProductSummary/Locwise",
    subdata: {
      loations: filteredLocationsId.length > 0 && filteredLocationsId,
      date: isoDate,
      toDate: isoToDate,
      is_multi_loc,
    },
  };

  const endpoint = "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};

export const fetchDailyCancelledOrderSummary = async ({
  fromDate,
  toDate,
  hasMultipleLocations,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const locations = JSON.parse(sessionStorage.getItem("locations") || "[]");
  const token = sessionStorage.getItem("token");
  const selectedLocationId = getSelectedLocationId();
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || locations.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = hasMultipleLocations
    ? {
        id: selectedLocationId,
        dataurl: "/api/Restaurant/DailyCancelledOrderSummary",
        subdata: {
          loations:
            filteredLocationsId.length > 0 ? filteredLocationsId : locations,
          date: isoDate,
          toDate: isoToDate,
          is_multi_loc,
        },
      }
    : {
        clientid: clientid,
        dataurl: "/api/Restaurant/DailyCancelledOrderSummary",
        subdata: {
          loations: locations,
          date: isoDate,
          toDate: isoToDate,
          is_multi_loc,
        },
      };

  const endpoint = hasMultipleLocations
    ? "multipleLocations-summarydetails"
    : "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  sessionStorage.setItem(
    "clientSettings",
    JSON.stringify(data?.client?.appSettings),
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};
export const fetchDailyCancelledOrderSummaryLocwise = async ({
  fromDate,
  toDate,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const token = sessionStorage.getItem("token");
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || filteredLocationsId.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = {
    clientid: clientid,
    dataurl: "/api/Restaurant/DailyCancelledOrderSummary/Locwise",
    subdata: {
      loations: filteredLocationsId.length > 0 && filteredLocationsId,
      date: isoDate,
      toDate: isoToDate,
      is_multi_loc,
    },
  };

  const endpoint = "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};

export const fetchSalesbyDepartmentSummary = async ({
  fromDate,
  toDate,
  hasMultipleLocations,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const locations = JSON.parse(sessionStorage.getItem("locations") || "[]");
  const token = sessionStorage.getItem("token");
  const selectedLocationId = getSelectedLocationId();
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || locations.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = hasMultipleLocations
    ? {
        id: selectedLocationId,
        dataurl: "/api/Restaurant/DailyDepartmentWiseSalesSummary",
        subdata: {
          loations:
            filteredLocationsId.length > 0 ? filteredLocationsId : locations,
          date: isoDate,
          toDate: isoToDate,
          is_multi_loc,
        },
      }
    : {
        clientid: clientid,
        dataurl: "/api/Restaurant/DailyDepartmentWiseSalesSummary",
        subdata: {
          loations: locations,
          date: isoDate,
          toDate: isoToDate,
          is_multi_loc,
        },
      };

  const endpoint = hasMultipleLocations
    ? "multipleLocations-summarydetails"
    : "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  sessionStorage.setItem(
    "clientSettings",
    JSON.stringify(data?.client?.appSettings),
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};

export const fetchSalesbyDepartmentSummaryLocwise = async ({
  fromDate,
  toDate,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const token = sessionStorage.getItem("token");
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  if (!clientid || filteredLocationsId.length === 0 || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = {
    clientid: clientid,
    dataurl: "/api/Restaurant/DailyDepartmentWiseSalesSummary/Locwise",
    subdata: {
      loations: filteredLocationsId.length > 0 && filteredLocationsId,
      date: isoDate,
      toDate: isoToDate,
      is_multi_loc,
    },
  };

  const endpoint = "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};

export const fetchHourlyProductSummaryDataLocwise = async ({
  fromDate,
  toDate,
  filteredLocationsId,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const token = sessionStorage.getItem("token");
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

  console.log(filteredLocationsId);
  

  if (!clientid || !filteredLocationsId || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = {
    clientid: clientid,
    dataurl: "/api/Restaurant/GetHourlyProductwiseSale/Summary",
    subdata: {
      loationID: Array.isArray(filteredLocationsId)
        ? filteredLocationsId[0]
        : filteredLocationsId,
      date: isoDate,
      toDate: isoToDate,
    },
  };

  const endpoint = "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  return {
    summary: Array.isArray(data?.result) ? data.result : [],
    locationWise: Array.isArray(data?.result) ? data.result : [],
  };
};

export const fetchHourlyProductSaleDataLocwise = async ({
  fromDate,
  toDate,
  page,
  limit,
  selectedCard,
  filteredLocationsId,
  locations,
}) => {
  const clientid = sessionStorage.getItem("clientId");
  const token = sessionStorage.getItem("token");
  const info = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const is_multi_loc = info?.is_multi_loc;

 

  if (!clientid || !fromDate || !token) {
    throw new Error("Missing required data");
  }

  const isoDate = new Date(fromDate).toISOString();
  const isoToDate = new Date(toDate).toISOString();

  const requestBody = {
    clientid: clientid,
    dataurl: "/api/Restaurant/GetHourlyProductwiseSale",
    subdata: {
      loationID:
        Array.isArray(filteredLocationsId) && filteredLocationsId.length > 0
          ? filteredLocationsId[0]
          : locations[0],
      date: isoDate,
      toDate: isoToDate,
      hour: selectedCard?.hour,
      page,
      limit,
    },
  };

  const endpoint = "summarydetails";

  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_API_URL}/clients/${endpoint}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  return data?.result;
};
